/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleResponseType } from '../../models/article-response-type';
import { CheckArticle } from '../../models/check-article';
import { KeyType } from '../../models/key-type';

export interface CheckArticle$Params {
  organizationSiteKey: KeyType;
  articleKey: KeyType;
      body: CheckArticle
}

export function checkArticle(http: HttpClient, rootUrl: string, params: CheckArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleResponseType>> {
  const rb = new RequestBuilder(rootUrl, checkArticle.PATH, 'patch');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('articleKey', params.articleKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleResponseType>;
    })
  );
}

checkArticle.PATH = '/organization-sites/{organizationSiteKey}/consignee/articles/{articleKey}/check';
